import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { enums } from "../lib";

/**
 * Check if user has an admin in any of the organisation
 */
export default () => {
    const { auth } = useSelector((state) => state);

    const result = useMemo(() => {
        if (auth && auth.adminGroups && auth.adminGroups.length) {
            return auth.adminGroups.some(
                ({ id }) => id === enums.auth.group.admin
            );
        }
        return false;
    }, [auth]);

    return result;
};
